import React from "react";

interface NavLoginHeaderTextProps {
  onClick?: (args: { redirect_uri: string }) => void;
}

export const NavLoginHeaderText = ({ onClick }: NavLoginHeaderTextProps) => (
  <span className="header-cta-text">
    Already a user?
    <a
      className="link"
      onClick={() =>
        onClick!({
          redirect_uri: window.location.origin + "/" + window.location.search,
        })
      }
    >
      Sign In
    </a>
  </span>
);

export default NavLoginHeaderText;
